import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const MobileMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const location = useLocation();
  const normalize = (p) => {
    if (!p) return '/';
    try {
      p = decodeURIComponent(p);
    } catch (e) {
      // ignore invalid sequences
    }
    return p.replace(/\/+$/g, '').toLowerCase() || '/';
  };

  const isActive = (targetPath, aliases = []) => {
    const p = normalize(location.pathname);
    const t = normalize(targetPath);
    if (t === '/home') return p === '/' || p === '/home';
    if (p === t || p.startsWith(t + '/')) return true;
    for (const a of aliases) {
      const na = normalize(a);
      if (p === na || p.startsWith(na + '/')) return true;
    }
    return false;
  };

  return (
    <div className="mobile-menu-container hide-desktop">
      <button className="nav-mobile-menu-btn" onClick={toggleMenu}>
        <i className="bi bi-list"></i>
      </button>

      {isOpen && (
        <div className="mobile-menu-dropdown">
        
        <Link to="/" className={`mobile-menu-item ${isActive('/home') ? 'active' : ''}`}>Home</Link>
        <Link to="/about" className={`mobile-menu-item ${isActive('/about') ? 'active' : ''}`}>About Me</Link>
        <Link to="/ren on issue" className={`mobile-menu-item ${isActive('/ren on issue') ? 'active' : ''}`}>Ren On Issues</Link>
        <Link to="/events/" className={`mobile-menu-item ${isActive('/events', ['/event-details']) ? 'active' : ''}`}>Events</Link>
        <Link to="/media/" className={`mobile-menu-item ${isActive('/media') ? 'active' : ''}`}>Media</Link>
        <Link to="/news/" className={`mobile-menu-item ${isActive('/news') ? 'active' : ''}`}>News</Link>
        <Link to="/ContactUs" className={`mobile-menu-item ${isActive('/ContactUs') ? 'active' : ''}`}>Contact</Link>
        <Link to="/sms-opt-in" className={`mobile-menu-item ${isActive('/sms-opt-in') ? 'active' : ''}`}>Text Updates</Link>
        <Link to="https://secure.actblue.com/donate/ren4mi" className="mobile-menu-item btn-primary-primary">Donate Now</Link>
          {/* Add more links as needed */}
        </div>
      )}
    </div>
  );
};

export default MobileMenu;
